/* Product gallery: thumbs sync with scroll-snap track, enlarge lightbox, variant media switching, hover zoom. */
(() => {
  if (window.__nsGallery) return;
  window.__nsGallery = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const init = (g) => {
    if (g.dataset.ready) return; g.dataset.ready = 1;
    const track = g.querySelector('[data-gallery-track]');
    const slides = [...track.children];
    const thumbs = [...g.querySelectorAll('[data-thumb]')];
    const go = (i) => { track.scrollTo({ left: slides[i].offsetLeft, behavior: reduced ? 'auto' : 'smooth' }); };
    const mark = (i) => thumbs.forEach((t, j) => t.setAttribute('aria-current', j === i ? 'true' : 'false'));
    thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.thumb))));
    const io = new IntersectionObserver((es) => es.forEach((e) => e.isIntersecting && mark(Number(e.target.dataset.index))), { root: track, threshold: 0.6 });
    slides.forEach((s) => io.observe(s));

    // variant media
    const scope = g.closest('[data-product-scope]') || document;
    scope.addEventListener('ns:variant-media', (e) => {
      const i = slides.findIndex((s) => s.dataset.mediaId === String(e.detail));
      if (i >= 0) go(i);
    });

    // enlarge lightbox
    const lb = g.querySelector('.gallery__lightbox');
    g.addEventListener('click', (e) => {
      const z = e.target.closest('[data-zoom]'); if (!z || !lb) return;
      window.NS.open(lb, z);
      requestAnimationFrame(() => document.getElementById(`${g.id}-Zoom-${z.dataset.zoom}`)?.scrollIntoView({ block: 'start' }));
    });

    // desktop hover: lens-style pan on the active image
    if (matchMedia('(hover: hover) and (pointer: fine)').matches && !reduced) {
      slides.forEach((s) => {
        const img = s.querySelector('img'); if (!img) return;
        s.addEventListener('pointermove', (e) => {
          const r = s.getBoundingClientRect();
          img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
          img.style.transform = 'scale(1.6)';
        });
        s.addEventListener('pointerleave', () => { img.style.transform = ''; });
      });
    }
  };
  const run = (root = document) => root.querySelectorAll('[data-gallery]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => run()) : run();
  document.addEventListener('ns:dom-updated', (e) => run(e.detail instanceof Element ? e.detail : document));
  document.addEventListener('shopify:section:load', (e) => run(e.target));
})();
